export default function EULADocument() {
  return (
    <div className="text-sm text-justify text-gray-700 leading-relaxed max-w-[800px] mx-auto p-5">
      <h1 className="text-xl font-semibold mb-2">END USER LICENSE AGREEMENT</h1>

      <h2 className="text-lg font-semibold mt-6 mb-3">TERMS AND CONDITIONS</h2>

      <p className="mb-3 font-semibold">
        IMPORTANT - READ CAREFULLY. THIS END USER LICENSE AGREEMENT ("EULA") IS A LEGAL AGREEMENT BETWEEN YOU AND
        EQUIPOOL, INC., AND OUTLINES THE TERMS FOR YOUR USAGE OF THE EQUIPOOL, INC. LENDING AND BORROWING LOAN
        TECHNOLOGY ("PLATFORM"), WHICH INCLUDES RELATED DOCUMENTATION, PROCESSES AND ESCROW. BY USING THE EQUIPOOL
        PLATFORM, YOU ACCEPT ALL THE TERMS AND CONDITIONS OF THIS AGREEMENT AND YOUR PAYMENT OBLIGATIONS CONTAINED
        HEREIN. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT USE THE EQUIPOOL PLATFORM.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">1. Definitions</h2>

      <p className="mb-3">
        (a) "Loan Application" means Licensor's Lending and Borrowing computer/software technology referred to as the
        "Platform", the concepts and techniques embodied and expressed in such programs and all support materials such
        as manuals, instructions, applications, contracts, escrow agreements, loan agreements, promissory notes and
        other documentation and the like; the software and system is the exclusive intellectual property of Equipool,
        Inc.
      </p>

      <p className="mb-3">
        (b) "Loan Terms" means any terms of the loan that is acquired or evaluated using the Loan Application by the
        Lenders or potential Lenders.
      </p>

      <p className="mb-3">(c) "License" means this Agreement, in its entirety.</p>

      <p className="mb-3">
        (d) "Update" means any revision that doesn't change the base functionality of the Platform such as a defect fix
        or patch.
      </p>

      <p className="mb-3">
        (e) "Licensee" means the "Borrower" and "Lender" or the user of the Platform and is the signatory to this
        Agreement.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">2. Grant of Non-Exclusive License</h2>

      <p className="mb-3">
        Equipool, Inc. ("Licensor"), is a Delaware corporation authorized to and doing business in California, and
        hereby grants to you as Licensee, so long as you are in compliance with the terms hereof, a limited,
        nonexclusive, non-transferable and non-sublicensable license to use the Platform solely for your use. No other
        rights in and to the Platform other than those granted herein, express or implied, are conveyed by Licensor to
        Licensee.
      </p>

      <p className="mb-3">
        The Platform is proprietary and confidential to Licensor and its affiliates. No title or ownership in the
        Platform is transferred to Licensee. Title to all applicable rights in copyrights, trademarks, trade secrets and
        any and all other intellectual property and/or proprietary rights in the Platform shall remain with Licensor and
        its affiliates. Licensee shall take appropriate action by instruction with its employees who are permitted
        access to the Loan Application to fulfill its obligations hereunder. All uses of Licensor's intellectual
        property shall inure to the benefit of Licensor. All ownership rights to any enhancements, modifications,
        developments, improvements and the like to the Platform made by Licensee, if any, shall belong solely to
        Licensor. Except as otherwise provided herein, any rights or remedies granted hereunder to either party shall be
        in addition to, and not in lieu of, any other rights or remedies of such party at law or in equity. All rights
        not expressly granted to Licensee under this License are retained by Licensor.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">3. Contemplated and Agreed Usage of the Platform</h2>

      <p className="mb-3">
        Licensor is granting Licensee the use of the Platform for the purpose of researching, exploring and potentially
        securing a home loan that is secured by real property as to the Borrower and as to the Lender, usage of the
        Platform for the purpose of evaluating potential loan opportunities (collectively referred to herein as the
        "Transaction"). The Transaction involves significant underwriting, evaluation, documentation and ultimately
        contract document preparation. Equipool, Inc. is not involved in any of the underwriting nor is it a decision
        maker relative to the loan terms, acquisition, funding or rates, nor does it prepare the legal documents, if
        any, necessary for the documentation of the Transaction. These tasks are performed by licensed escrow companies
        and the title insurance and policies are underwritten and provided by licensed title insurance providers.
        Licensee is using the Platform for the sole purpose of exploring Transaction options and perhaps locating a
        financial opportunity that is acceptable to Licensee. Licensor is not verifying, representing or warranting that
        any Transaction will occur or that Licensee shall be offered any terms of the contemplated or desired
        Transaction. Moreover, Licensor is not representing, warranting or vouching for any of the terms or conditions
        and makes no representation as to the ability of the Lender to timely fund and service the Transaction nor the
        Borrower's ability to repay the obligation as required by a Transaction. The decision of Licensee to enter into
        a Transaction with another on this Platform is solely the decision of Licensee and Licensor provides no
        endorsements or advice as to whether the Transaction is fit for this particular Licensee.
      </p>

      <p className="mb-3">
        By creating an account, you consent to receive transactional SMS messages from Equipool for account security,
        including one-time passcodes (OTP). These messages are non-marketing and sent only in response to your actions.
        You may opt out at any time by replying STOP.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">4. Fees Due Licensor Upon Completed Transaction</h2>

      <p className="mb-3">
        Licensee acknowledges and agrees that the use of this Loan Application shall cost Licensee a Licensing Fee in an
        amount equal to 0.5% of the gross value of the Transaction, or money lent. For example, if Licensee secures a
        loan for $100.00, Licensee shall pay a fee of $0.50, or .5% to Licensor at the close of escrow.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">5. Limitations</h2>

      <p className="mb-3">
        In consideration for the grant of the license and/or use of the Platform, you understand and agree that:
      </p>

      <p className="mb-3">
        (a) In no event shall Licensee be entitled to remove or tamper with any proprietary notices contained in the
        Platform, or in or on any other product, component, or other Platform item delivered by Licensor to Licensee;
      </p>

      <p className="mb-3">
        (b) Licensee shall not modify, translate, reverse engineer, decompile, disassemble the Platform or create
        derivative works based on the Platform, or any portion thereof;
      </p>

      <p className="mb-3">
        (c) If Licensee attempts to use, copy, disclose, or transfer any portion of the Platform or any modification
        thereof or Licensor's intellectual property in a manner contrary to the terms of this License or in derogation
        of Licensor's rights, whether those rights are explicitly stated, determined by law, or otherwise, Licensor
        shall have the right, in addition to any other legal remedies available, to injunctive relief enjoining such
        acts, including but not limited to breaches relating to intellectual property without the posting of bond, it
        being acknowledged by Licensee that all other remedies are inadequate at law and cumulative;
      </p>

      <p className="mb-3">
        (d) The Platform is licensed as a service. Licensee shall not remove any proprietary notices, labels or marks on
        the Platform.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">6. Warranty and Platform Upgrades; Limitation of Liability</h2>

      <p className="mb-3">
        If any modifications are made to the Platform by Licensee; if Licensee violates the terms of this License, then
        this warranty shall immediately be void and of no further force and effect. This warranty shall not apply if the
        Platform is used on or in conjunction with the Platform other than that for which the Platform was designed to
        be used. Licensee hereby acknowledges and agrees that Licensor will have no liability for any claim, suit,
        action, or proceeding that arises out of or results from Licensee's use of the Platform. Licensee will waive any
        claims that Licensee may have against Licensor, any of its affiliates, or officers, directors, employees, or
        agents of Licensor or any of its affiliates for Losses arising out of or resulting from any of the following:
        Licensee's use of the Platform; Licensee's failure to comply with any applicable laws or regulations; any
        willful, fraudulent, or negligent acts or omissions of Licensee; Licensee's breach of any representation,
        warranty, or obligation of Licensee set forth in this EULA or the underlying Agreement; a claim that any
        Transaction, Transaction document, the Platform's content, or Licensee's use thereof infringes any Intellectual
        Property Right of a third party; and the use of the Platform by a third party.
      </p>

      <p className="mb-3 uppercase">
        EXCEPT AS EXPRESSLY STATED ABOVE, THE PLATFORM AND ITS USE ARE LICENSED AND ANY SERVICES ARE RENDERED "AS IS"
        AND LICENSOR AND ITS SUPPLIERS MAKES NO WARRANTY OR REPRESENTATION, EXPRESS OR IMPLIED, WHETHER OF
        MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE, NONINFRINGEMENT, THAT THE PLATFORM IS ERROR OR BUG FREE,
        OF USE OR OTHERWISE, DURING THE USE, DELIVERY OR SERVICING OF THE PLATFORM. LICENSOR AND ITS SUPPLIERS SHALL NOT
        BE SUBJECT TO AND DISCLAIMS: (1) ANY OTHER OBLIGATIONS OR LIABILITIES ARISING OUT OF BREACH OF CONTRACT OR OF
        WARRANTY; AND (2) ANY OBLIGATIONS WHATSOEVER ARISING FROM STRICT LIABILITY, TORT (INCLUDING NEGLIGENCE AND
        STRICT LIABILITY) OR ARISING UNDER ANY OTHER THEORIES OF LAW WITH RESPECT TO THE PLATFORM SOLD OR SERVICES
        RENDERED BY LICENSOR, OR ANY UNDERTAKINGS, ACTS, OR OMISSIONS RELATING THERETO. IN NO EVENT SHALL LICENSOR BE
        LIABLE TO LICENSEE FOR ANY SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES (I.E., LOSS OF USE, LOST
        PROFITS, LOST DATA) ARISING OUT OF, OR AS THE RESULT OF, THE SALE, DELIVERY, NON-DELIVERY, SERVICING, USE,
        MIS-USE OR LOSS OF USE OF THE PLATFORM OR ANY PART THEREOF, OR FOR ANY CHARGES OR EXPENSES OF ANY NATURE
        INCURRED WITHOUT LICENSOR'S PRIOR WRITTEN CONSENT, EVEN THOUGH LICENSOR HAS BEEN NEGLIGENT. IN NO EVENT SHALL
        LICENSOR'S LIABILITY UNDER ANY CLAIM MADE BY LICENSEE EXCEED THE NET PAYMENT TO LICENSOR IN RESPECT OF WHICH
        DAMAGES ARE CLAIMED. LICENSEE AGREES THAT THE PROVISIONS OF THIS SECTION ARE REASONABLE AND ENABLE LICENSOR TO
        PROVIDE THE PLATFORM AT THE FEES CHARGED TO LICENSEE AND THAT SAME ARE LOWER THAN THE FEES THAT WOULD BE CHARGED
        BY LICENSOR IF THESE PROVISIONS WERE NOT IN EFFECT.
      </p>

      <p className="mb-3">
        Nothing herein shall obligate Licensor to improve or otherwise support any Platform licensed hereunder when and
        if Licensor shall no longer improve or support the Platform in the ordinary course of Licensor's ongoing
        business. All support, enhancements, modifications and updates delivered to Licensee by Licensor, if any, shall
        be subject to the same protections, restrictions, limited warranty, and limitations on copying and tampering as
        set forth elsewhere herein.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">7. Commencement of Actions</h2>

      <p className="mb-3">
        In the event of a dispute between the Licensee and Licensor that cannot be resolved between them, the parties
        shall first escalate the dispute to the principal of Licensee and the CEO for Licensor for evaluation and
        resolution. If no resolution is achieved within thirty (30) days after such submission, then either party may
        submit their dispute to non-binding mediation prior to initiating litigation. Each party shall bear its own
        costs and expenses of participating in the mediation (including without limitation, attorneys' fees) and each
        party shall bear one-half (1/2) of the costs and expenses of the mediator. The matters discussed or revealed in
        the mediation session shall not be revealed in any subsequent litigation. In the event the matter is not
        resolved in the mediation, suit may be brought. Nothing in this Section 7 shall be deemed to limit a party's
        access to the court system to pursue a remedy that is limited to injunctive relief. This Agreement and any
        transaction between Licensee and Licensor hereunder shall be governed by, construed and interpreted in
        accordance with the laws of the State of California.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">8. Force Majeure</h2>

      <p className="mb-3">
        Licensor shall not be liable for any default or delay in performance if caused, directly or indirectly, by acts
        of God, war, force of arms, fire, the elements, riot, labor disputes, terrorism, border issues, picketing or
        other labor controversies, sabotage, civil commotion, accidents, any governmental action, prohibition or
        regulation, delay in transportation facilities, shortage or breakdown of or inability to obtain or non-arrival
        of any labor, material or equipment used in the manufacture of the Platform, failure of any party to perform any
        contract with Licensor relative to the production of the Platform, or from any cause whatsoever beyond
        Licensor's control, whether or not such cause be similar or dissimilar to those enumerated. Licensor shall
        promptly notify Licensee of the happening of any such contingency and of the contemplated effect thereof on the
        manufacture and delivery of the Platform. The time for delivery specified herein shall be extended during the
        continuance of such conditions and for a reasonable time thereafter.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">9. Licensor's Confidential Information</h2>

      <p className="mb-3">
        Any specifications, drawings, plans, notes, instructions, engineering notices, or technical data of Licensor
        furnished to Licensee shall be deemed to be incorporated herein by reference the same as if fully set forth.
        Licensor shall at all times retain title to all such documents and intellectual property, proprietary and
        confidential information, and Licensee shall not disclose same to any party other than Licensor or a party duly
        authorized by Licensor. Licensee shall treat and maintain as confidential all technical information, know-how,
        trade secrets and intellectual property concerning the Platform. Licensee agrees not to disclose or provide any
        of the Platform and its operation to any third party without Licensor's express written permission. Upon
        Licensor's request, Licensee shall promptly return to Licensor all such documents and copies thereof. If
        Licensee attempts to use, copy, disclose, or transfer any portion of the confidential information in a manner
        contrary to the terms of this License or in derogation of Licensor's rights, whether those rights are explicitly
        stated, determined by law, or otherwise, Licensor shall have the right, in addition to any other legal remedies
        available, without the posting of a bond, to injunctive relief enjoining such acts, it being acknowledged by
        Licensee that all other remedies are inadequate and cumulative.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">10. Limitation on Assignment</h2>

      <p className="mb-3 uppercase">THIS LICENSE AND AGREEMENT MAY NOT BE ASSIGNED, SHARED, OR TRANSFERRED.</p>

      <p className="mb-3">
        Any attempted assignment, transfer or encumbering by Licensee shall be null and void. All of the covenants,
        conditions and obligations contained in this License shall be binding upon and shall inure to the benefit of the
        respective successors and assignees of Licensor and (subject to the restrictions of this Section) Licensee.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">11. Compliance with Laws</h2>

      <p className="mb-3">
        Licensee shall ensure that its personnel are, at all times, educated and trained in the proper use and/or
        operation of the Platform and that the Platform are used in accordance with any and all applicable manuals,
        documentation and instructions. In addition to the foregoing, Licensee shall comply with all applicable (present
        and future) federal, state and local, USA and foreign (any country, jurisdiction or place where the Licensee
        resides, including but not limited to truth and lending laws and privacy protections. Licensee shall indemnify
        and hold Licensor harmless against all losses, claims, suits, penalties, liabilities, damages, judgments, costs
        and expenses, including attorneys' fees, as incurred, arising out of Licensee's failure to comply with this
        Section, or any applicable federal, state or local, ordinance, regulation, statute, rule or order, USA or
        foreign.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">12. Licensee's Default</h2>

      <p className="mb-3">
        If Licensee defaults in the performance of any of its obligations hereunder, or becomes subject to insolvency,
        receivership, or bankruptcy proceedings, or makes an assignment for the benefit of creditors, or without
        Licensor's written consent, sells, transfers, leases, or permits any lien or attachment on the Platform then
        Licensor may treat any unpaid balance of the price as immediately due and payable and exercise any and all
        rights of a secured creditor under the laws of the State of California.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">13. Termination</h2>

      <p className="mb-3">
        If Licensee fails to comply with any of the terms and conditions of this License, including, but not limited to,
        failing to make any required payments to Licensor, Licensor may, upon its election and in addition to any other
        remedies that it may have, at any time, terminate the license or permission which forms a part of this License,
        or terminate this License in its entirety by giving immediate notice to Licensee. Except as specifically
        provided in this License, upon termination of any license or permission granted by Licensor pursuant to this
        License or upon termination of this License in its entirety, there shall be no obligation to refund any fees.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">14. Entire Agreement</h2>

      <p className="mb-3">
        This document, together with any information or documents incorporated herein by reference, any annexes,
        appendices and/or exhibits attached hereto, contains the entire agreement between Licensor and Licensee and
        constitutes the final, complete and exclusive expression of the terms of the License, all prior or
        contemporaneous written or oral agreements or negotiations with respect to the subject matter hereof being
        merged herein. Any later Licensee correspondence, purchase orders and the like shall have no effect. None of the
        provisions of this License shall be deemed to have been waived by any act of or acquiescence on the part of
        Licensor, its agents, or employees, but only by an instrument in writing signed by an authorized representative
        of Licensor. No waiver by Licensor of any provisions of this License shall constitute a waiver of any other
        provision or of the same provision on another occasion. This License may be amended only in writing signed by
        each of the parties hereto. If any provision or portion thereof of this License is held by a court of competent
        jurisdiction to be invalid, void, or unenforceable, the remaining provisions or portions of this License shall
        remain in full force and effect and shall in no way be affected, impaired or invalidated.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">15. Governing Law</h2>

      <p className="mb-3">
        This License shall be governed by the laws of the State in which the real property, securing the indebtedness of
        the loan contemplated herein is located, without regard to choice of law rules, and Licensee hereby submits to
        the jurisdiction of the federal and state courts of the state in which the real property securing the
        indebtedness is located. The official text of the Agreement and any Addendum or any notices given on accounts or
        statements required hereby shall be in English. An action by Licensee arising out of or related to this License
        shall be commenced within one (1) year from the date the right, claim, demand or cause of action shall first
        occur, or be barred forever.
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">16. U.S. Government End-Users</h2>

      <p className="mb-3">
        The Platform is a "commercial item," as that term is defined at 48 C.F.R. 2.101 (OCT 1995), consisting of
        "commercial computer applications" and "commercial computer documentation," as such terms are used in 48 C.F.R.
        12.212 (SEPT 1995), and is provided to the U.S. Government only as a commercial end item. Government end users
        acquire the Platform under the following terms: (i) for acquisition by or on behalf of civilian agencies,
        consistent with the terms set forth in 48 C.F.R. 12.212 (SEPT 1995); or (ii) for acquisition by or on behalf of
        units of the Department of Defense, consistent with the terms set forth in 48 C.F.R. 227.7202-1 through
        227.7202-4 (JUNE 1995).
      </p>

      <h2 className="text-lg font-semibold mt-6 mb-3">17. Miscellaneous</h2>

      <p className="mb-3">
        (a) In the event of the bankruptcy or insolvency of Licensee, Licensor, shall be entitled to cancel any
        outstanding pending Transaction and shall be entitled to reimbursement for all costs and expenses incurred, plus
        incidental and consequential damages.
      </p>

      <p className="mb-3">
        (b) Licensee shall defend and indemnify Licensor and its affiliates, agents, directors, officers, members and
        employees and hold them harmless from and against all damages, claims, judgments and liabilities by or to third
        parties (including attorney fees and litigation costs incurred) resulting from injury or death of any person or
        physical loss or damage to property, or money arising out of the operation or use or misuse of the Platform or
        the alteration and/or defective maintenance of the Platform; any breach or claimed breach of the terms of this
        License or warranties provided herein; and/or Licensee's violation of applicable laws, rules or regulations in
        connection with the Platform. Such indemnity shall survive the expiration or termination of this License and
        shall apply regardless of the form of legal action, whether in contract or in tort, including negligence.
      </p>

      <p className="mb-3">
        (c) The official version of this License is in English and it shall be construed and interpreted solely in
        English. All documents, schedules, notices, correspondence, communications, price lists or legal proceedings
        consequent upon or ancillary or relating directly or indirectly to this Agreement, or forming a part thereof or
        resulting therefrom, shall be drawn up in English only. To the extent this License is translated into another
        language, if there is any discrepancy between the English version of this Agreement and the translated version
        of this Agreement, the English version shall control.
      </p>

      <p className="mb-3 uppercase">
        (d) IT IS EXPRESSLY UNDERSTOOD AND AGREED THAT EACH AND EVERY PROVISION OF THIS AGREEMENT WHICH PROVIDES FOR A
        LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES OR EXCLUSION OF DAMAGES, IS INTENDED BY THE PARTIES TO BE
        SEVERABLE AND INDEPENDENT OF ANY OTHER PROVISION AND TO BE ENFORCED AS SUCH.
      </p>

      <p className="mb-3">
        (e) All notices required to be given hereunder shall be in writing. Notices shall be considered delivered and
        effective upon receipt when sent by telecopy with proof of reception or by registered or certified mail postage
        pre-paid, return receipt requested, addressed to the parties as set forth above. Either party, upon written
        notice to the other, may change the address to which future notices shall be sent.
      </p>

      <p className="mb-3">
        (f) Licensee shall not, directly or indirectly, export or transmit any data or Platform information covered by
        this License to any country to which such export or transmission is restricted by applicable regulations or
        statutes of the United States or any agency thereof, without the prior written consent of the U.S. Department of
        Commerce and of any other required governmental agency. Licensee covenants that the Platform is not intended for
        any nuclear use or chemical or biological weapons production. Licensee shall comply with all export control laws
        and shall defend, indemnify and hold Licensor and all Licensor's resellers, distributors and suppliers harmless
        from any claims arising out of Licensee's violation of such export control laws.
      </p>

      <p className="mb-3">
        (g) Should any act or omission of Licensee cause delays and/or an increase or decrease in the cost of Licensor's
        performance of this Agreement, an equitable adjustment to the timetable and/or amounts due under this Agreement
        shall be made. Upon its awareness of such act or omission affecting the schedule and/or costs, Licensor shall
        provide written notice of same with the Licensee.
      </p>

      <p className="mb-3">
        (h) The Platform is protected by the patent and copyright laws of the United States and related international
        patent and copyright treaties.
      </p>

      <hr className="mt-10 mb-5 border-t border-gray-300" />

      <p className="text-center font-semibold">END OF TERMS AND CONDITIONS</p>
    </div>
  );
}
